/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-10-27 22:22:33
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-08-01 17:59:29
 */
const cooperationProgress = [
	{
		path: '/cooperationProgress',
		component: null,
		name: '合作',
		id: 2,
		parentId: 0,
		keepAlive: false,
		showBread: false,
		visible: true,
		redirect: '/cooperationProgress/list',
		children: [
			{
				path: 'list',
				component: 'cooperationProgress/list',
				name: '合作进度',
				parentId: 2,
				showBread: true,
				useTemplate: false,
				visible: true,
				children: null,
			},
			{
				path: 'details',
				component: 'cooperationProgress/list/details',
				name: '合作进度详情',
				parentId: 2,
				showBread: true,
				useTemplate: true,
				visible: false,
				children: null,
			},
			{
				path: 'record',
				component: 'cooperationProgress/record',
				name: '导出记录',
				parentId: 2,
				showBread: true,
				useTemplate: true,
				visible: false,
				children: null,
			},
		],
	},
];
export default cooperationProgress;
